import { PlusOutlined } from "@ant-design/icons";
import styles from "./AddTab.module.scss";

interface AddTabPropsI {
  onClick: () => void;
}

export default function AddTab(props: AddTabPropsI) {
  return (
    <div className={styles.wrapper} onClick={props.onClick}>
      <PlusOutlined className={styles.icon} />
    </div>
  );
}
